import { render, staticRenderFns } from "./PrintLink.vue?vue&type=template&id=c4c4627c"
import script from "./PrintLink.vue?vue&type=script&lang=js"
export * from "./PrintLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports